import { SliderMarkLabel } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

const CustomMarkLabel: React.FC<CustomMarkLabelProps> = ({
  dataIndex,
  children,
  style,
  ...other
}) => {
  function getColor() {
    switch (dataIndex) {
      case 0:
        return "#ac3333";
      case 1:
        return "#ceaa73";
      case 2:
        return "#ceaa73";
      case 3:
        return "#ac3333";

      default:
        return "#ac3333";
    }
  }

  function getSide() {
    switch (dataIndex) {
      case 0:
      case 1:
        return "custom-mark-label-left";
      case 2:
      case 3:
        return "custom-mark-label-right";

      default:
        return "";
    }
  }

  return (
    <SliderMarkLabel
      {...other}
      style={{ ...style, color: getColor() }}
      className={`custom-mark-label ${getSide()}`}
    >
      {children}
    </SliderMarkLabel>
  );
};

export default CustomMarkLabel;

export interface CustomMarkLabelProps {
  dataIndex: number;
  style: CSSProperties;
  children?: ReactNode;
}
